import React from 'react';
import Panel from './Panel';
import CompanyList from '../../components/Panel/RegisterCompany/CompanyList';



const CompanyListAllPage = (e) => {
  let t = e.params.table;
  
  if (t != undefined && t.length > 0)
    t = e.params.table;
  else
    t = 'all';

  return (
    <Panel>
      <div>
        <CompanyList table={t} />
      </div>
    </Panel>

  );
};

export default CompanyListAllPage;



/** WEBPACK FOOTER **
 ** ./src/containers/Panel/CompanyListAllPage.js
 **/